function e(n,r){return Object.prototype.hasOwnProperty.call(n,r)}export{e as hasOwnProperty};
//# sourceMappingURL=has-own-property.js.map
